var map = {
	"./AVIcon.png": 463,
	"./AVIcon_MiniSet.png": 464,
	"./BARIcon.png": 465,
	"./BARIcon_MiniSet.png": 466,
	"./BOTIcon.png": 467,
	"./BRMIcon.png": 468,
	"./BTIcon.png": 469,
	"./BotBIcon.png": 470,
	"./BotBIcon_MiniSet.png": 471,
	"./ClassicIcon.png": 236,
	"./ClassicIconSelected.png": 237,
	"./DALIcon.png": 472,
	"./DHIIcon.png": 473,
	"./DMFIcon.png": 474,
	"./DMFIcon_MiniSet.png": 475,
	"./DRGIcon.png": 476,
	"./DRGIcon_MiniSet.png": 477,
	"./EventIcon.png": 478,
	"./GILIcon.png": 479,
	"./GangsIcon.png": 480,
	"./GryphonIcon.png": 238,
	"./GryphonIconSelected.png": 239,
	"./GvGIcon.png": 481,
	"./HallOfFameIcon.png": 482,
	"./HydraIcon.png": 483,
	"./ICCIcon.png": 484,
	"./KaraIcon.png": 485,
	"./LOEIcon.png": 486,
	"./LOOTIcon.png": 487,
	"./NaxxIcon.png": 488,
	"./OGIcon.png": 489,
	"./PoAIcon.png": 490,
	"./REVIcon.png": 491,
	"./REVIcon_MiniSet.png": 492,
	"./RLKIcon.png": 493,
	"./RLKIcon_MiniSet.png": 494,
	"./SCHIcon.png": 495,
	"./SCIcon.png": 496,
	"./SCIcon_MiniSet.png": 497,
	"./SWIcon.png": 498,
	"./SWIcon_MiniSet.png": 499,
	"./Set1_Icon.png": 240,
	"./Set1_IconSelected.png": 241,
	"./TGTIcon.png": 500,
	"./TOYIcon.png": 501,
	"./TOYIcon_MiniSet.png": 502,
	"./TRLIcon.png": 503,
	"./TTNIcon.png": 504,
	"./TTNIcon_MiniSet.png": 505,
	"./TwistIcon.png": 506,
	"./UNGIcon.png": 507,
	"./UldumIcon.png": 508,
	"./WWIcon.png": 509,
	"./WWIcon_MiniSet.png": 510,
	"./WolfIcon.png": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;